import React from "react";
import { FaSwatchbook } from "react-icons/fa";
import { BASE_URL } from "../constants";
import CatalogAdminPage from "./CatalogAdminPage";

const Variations: React.FC = () => (
  <CatalogAdminPage
    title="Variaciones"
    subtitle="Administre variaciones reutilizables como color, talla o material."
    singularLabel="Variacion"
    searchPlaceholder="Buscar por nombre de variacion..."
    endpoint={`${BASE_URL}/variations`}
    Icon={FaSwatchbook}
  />
);

export default Variations;
